module.exports = __webpack_public_path__ + "media/coffee-preferences/adventurousness_unsure-fe65e061.png";